import RecipeSlide from './RecipeSlide';

export default RecipeSlide;
